import React, { useEffect } from 'react';
import ErrorBoundary from './components/Common/ErrorBoundary';
import { PublicAuthProvider } from './contexts/PublicAuthContext';
import { UIProvider } from './contexts/UIContext';
import PublicMarketingShell from './PublicMarketingShell';
import lazyWithRetry from './utils/lazyWithRetry';
import { isTauriApp } from './utils/tauriHelper';

const AuthenticatedApp = lazyWithRetry(() => import('./AppV5'), 'authenticated-app');

const MarketingEntry = () => {
  useEffect(() => {
    if (!isTauriApp()) return;
    import('./services/offlineFirstData')
      .then(({ offlineFirstData }) => offlineFirstData.init())
      .catch((error) => {
        console.warn('[MarketingEntry] Offline-first data initialization failed:', error);
      });
  }, []);

  return (
    <ErrorBoundary level="app">
      <PublicAuthProvider>
        <UIProvider>
          <PublicMarketingShell AuthenticatedApp={AuthenticatedApp} />
        </UIProvider>
      </PublicAuthProvider>
    </ErrorBoundary>
  );
};

export default MarketingEntry;
